import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { loadRuntimeConfig } from '@core/config/runtime-config.service';
import { WebApp } from './app/web-app';
import { webAppConfig } from './app/web-app.config';

// Registers the `pwa-camera-modal` custom element that @capacitor/camera's web implementation
// looks for -- without it, `Camera.takePhoto()` silently falls back to a plain file-input picker
// instead of prompting for camera access. No-op on native platforms (Capacitor never reaches this
// path there, since it uses the real native camera plugin instead).
defineCustomElements(window);

async function main(): Promise<void> {
  // Resolved before the injector even exists, so no app-initializer ordering can capture a
  // provider (e.g. the API_URL token) with the stale, compiled-in fallback -- see
  // runtime-config.service.ts.
  await loadRuntimeConfig();
  await bootstrapApplication(WebApp, webAppConfig);
}

main().catch(error => console.error(error));

